import { CHANGE_ENABLED_BUTTON, CHANGE_BOTTOM_BUTTON_PAYLOAD } from './types';

export const changeEnabledButtonAction = enabledButton => ({
  type: CHANGE_ENABLED_BUTTON,
  extraProperties: {
    enabledButton,
  },
});

export const changeBottomButtonPayloadAction = payload => ({
  type: CHANGE_BOTTOM_BUTTON_PAYLOAD,
  extraProperties: {
    payload,
  },
});
